import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  resetPassword: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
};

export const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: INITIAL_STATE,
  reducers: {
    fetchResetPassword: (state) => {
      state.resetPassword.isLoading = true;
    },
    fetchResetPasswordSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      resetPassword: {
        ...state.resetPassword,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchResetPasswordFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      resetPassword: {
        ...state.resetPassword,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  fetchResetPassword,
  fetchResetPasswordSuccess,
  fetchResetPasswordFailure,
} = resetPasswordSlice.actions;
export const resetPasswordReducer = resetPasswordSlice.reducer;
